import Card from "./Card";
import {findMetadata} from "../../../../../util/helpers";
import {formatDateText} from "../../../../../util/formatter";
import {DefaultTimelineMetadata} from "../../../../../util/types";
import IconCheck from "../../../../icons/IconCheck.tsx";
import IconMail from "../../../../icons/IconMail.tsx";

export default function OrderConfirmedCard({metadata}: { metadata: DefaultTimelineMetadata[] }) {
    const product_display_name = findMetadata('product_display_name', metadata);
    const order_date = findMetadata('order_date', metadata);

    return <Card
        position="start"
        done={true}
        title="Ordre&shy;bekræftelse"
        statusIcon={IconCheck}
        icon={IconMail}
    >
        <p>Du har bestilt {product_display_name}.</p>
        {order_date &&
            <p className={'date'}>{formatDateText(order_date)}</p>
        }
    </Card>
}
